import { getPrimaryRole } from "../auth/access";
import { isExamInstructorProfile } from "../constants/instructors";
import { LS_ULTRA_MONTH_KEY } from "../components/APanel/CalendarExtreme/extremeZoomStorage";

// Cine are calendarul nou și unde e fiecare calendar.
// Administratorii și managerii — calendarul instructorilor; instructorii — „Orarul meu”, iar SUPERIOR și
// „Orar practice” (toți instructorii, fără modificări). Ce vede și ce poate fiecare decide serverul.

const ENABLED_ROLES = new Set(["ADMIN", "MANAGER", "INSTRUCTOR"]);

export const NEW_CALENDAR_PATH = Object.freeze({
   ADMIN: "/admin/calendar-nou",
   MANAGER: "/manager/calendar-nou",
   INSTRUCTOR: "/instructor/calendar-nou",
});

export const OLD_CALENDAR_PATH = Object.freeze({
   ADMIN: "/admin/orar-extreme",
   MANAGER: "/manager/orar-extreme",
   INSTRUCTOR: "/instructor/orarul-meu",
});

export function canUseCalendarV2(user) {
   return ENABLED_ROLES.has(getPrimaryRole(user));
}

const choiceKey = (user) => `calendar.engine:${user?.id ?? ""}`;

/** Ce calendar a ales omul ultima dată pe dispozitivul ăsta: "v2" sau "v1". */
export function readCalendarChoice(user) {
   try {
      return localStorage.getItem(choiceKey(user)) === "v2" ? "v2" : "v1";
   } catch {
      return "v1";
   }
}

export function writeCalendarChoice(user, choice) {
   try {
      localStorage.setItem(choiceKey(user), choice === "v2" ? "v2" : "v1");
   } catch {}
}

// Luna deschisă trece dintr-un calendar în celălalt la comutare (același format „AAAA-LL”).
// Prin meniu fiecare calendar se deschide pe luna lui, ca până acum.
export const NEW_MONTH_KEY = "__CV2_MONTH";
const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

function currentMonthKey(now = new Date()) {
   return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
}

/** Spre calendarul nou: luna din cel de acum (fără lună salvată, el arată luna curentă). */
export function carryMonthToNew() {
   try {
      const month = localStorage.getItem(LS_ULTRA_MONTH_KEY) || "";
      localStorage.setItem(NEW_MONTH_KEY, MONTH_RE.test(month) ? month : currentMonthKey());
   } catch {}
}

/** Spre calendarul de acum: luna deschisă în cel nou. */
export function carryMonthToOld(monthKey) {
   const month = String(monthKey || "");
   if (!MONTH_RE.test(month)) return;
   try {
      localStorage.setItem(LS_ULTRA_MONTH_KEY, month);
   } catch {}
}

// „Examene” în calendarul nou: calendarul de examen practic de acum, cu aceeași lună ca „Lecții”.
/** Cheia lunii din calendarul de examen de acum (același format „AAAA-LL”). */
export const EXAM_MONTH_KEY = "__PRACTICAL_EXAM_MONTH";

/** Spre „Examene”: luna deschisă la „Lecții”. */
export function carryMonthToExams(monthKey) {
   const month = String(monthKey || "");
   if (!MONTH_RE.test(month)) return;
   try {
      localStorage.setItem(EXAM_MONTH_KEY, month);
   } catch {}
}

/** Înapoi la „Lecții”: luna la care a ajuns calendarul de examen ("" — nu e una salvată). */
export function monthFromExams() {
   try {
      const month = localStorage.getItem(EXAM_MONTH_KEY) || "";
      return MONTH_RE.test(month) ? month : "";
   } catch {
      return "";
   }
}

/**
 * Cine are „Examene” în calendarul nou — ca „Orar interne” de acum: administratorii și managerii (tot),
 * instructorul EXAMEN (doar sloturile lui, notează rezultatul). Ceilalți nu au comutatorul.
 */
export function canSeeExams(user, instructor) {
   const role = getPrimaryRole(user);
   if (role === "ADMIN" || role === "MANAGER") return true;
   return role === "INSTRUCTOR" && isExamInstructorProfile(instructor);
}

/** „Orar practice” al instructorului SUPERIOR, în fiecare calendar. */
export const PRACTICE_PATH = Object.freeze({
   NEW: "/instructor/calendar-nou/practice",
   OLD: "/instructor/orar-practice",
});

const isInstructor = (user) => getPrimaryRole(user) === "INSTRUCTOR";

/** `practice` — din / spre „Orar practice” (doar instructorii; ceilalți au un singur calendar). */
export function newCalendarPathFor(user, { practice = false } = {}) {
   if (practice && isInstructor(user)) return PRACTICE_PATH.NEW;
   return NEW_CALENDAR_PATH[getPrimaryRole(user)] || "";
}

export function oldCalendarPathFor(user, { practice = false } = {}) {
   if (practice && isInstructor(user)) return PRACTICE_PATH.OLD;
   return OLD_CALENDAR_PATH[getPrimaryRole(user)] || "/";
}
